var map = {
	"./ar-SA.md": "./src/translations/help/ar-SA.md",
	"./be-BY.md": "./src/translations/help/be-BY.md",
	"./bg-BG.md": "./src/translations/help/bg-BG.md",
	"./bn-BD.md": "./src/translations/help/bn-BD.md",
	"./cs-CZ.md": "./src/translations/help/cs-CZ.md",
	"./da-DK.md": "./src/translations/help/da-DK.md",
	"./de-DE.md": "./src/translations/help/de-DE.md",
	"./el-GR.md": "./src/translations/help/el-GR.md",
	"./en-GB.md": "./src/translations/help/en-GB.md",
	"./en-US.md": "./src/translations/help/en-US.md",
	"./es-ES.md": "./src/translations/help/es-ES.md",
	"./fi-FI.md": "./src/translations/help/fi-FI.md",
	"./fr-FR.md": "./src/translations/help/fr-FR.md",
	"./he-IL.md": "./src/translations/help/he-IL.md",
	"./hi-IN.md": "./src/translations/help/hi-IN.md",
	"./hr-HR.md": "./src/translations/help/hr-HR.md",
	"./hu-HU.md": "./src/translations/help/hu-HU.md",
	"./id-ID.md": "./src/translations/help/id-ID.md",
	"./it-IT.md": "./src/translations/help/it-IT.md",
	"./ja-JP.md": "./src/translations/help/ja-JP.md",
	"./km-KH.md": "./src/translations/help/km-KH.md",
	"./ko-KR.md": "./src/translations/help/ko-KR.md",
	"./me-ME.md": "./src/translations/help/me-ME.md",
	"./mk-MK.md": "./src/translations/help/mk-MK.md",
	"./ne-NP.md": "./src/translations/help/ne-NP.md",
	"./nl-NL.md": "./src/translations/help/nl-NL.md",
	"./no-NO.md": "./src/translations/help/no-NO.md",
	"./pl-PL.md": "./src/translations/help/pl-PL.md",
	"./pt-BR.md": "./src/translations/help/pt-BR.md",
	"./pt-PT.md": "./src/translations/help/pt-PT.md",
	"./pt-TL.md": "./src/translations/help/pt-TL.md",
	"./ro-RO.md": "./src/translations/help/ro-RO.md",
	"./ru-MD.md": "./src/translations/help/ru-MD.md",
	"./ru-RU.md": "./src/translations/help/ru-RU.md",
	"./sh-HR.md": "./src/translations/help/sh-HR.md",
	"./si-LK.md": "./src/translations/help/si-LK.md",
	"./sk-SK.md": "./src/translations/help/sk-SK.md",
	"./sq-AL.md": "./src/translations/help/sq-AL.md",
	"./sq-MK.md": "./src/translations/help/sq-MK.md",
	"./sr-CS.md": "./src/translations/help/sr-CS.md",
	"./sr-ME.md": "./src/translations/help/sr-ME.md",
	"./sr-RS.md": "./src/translations/help/sr-RS.md",
	"./sr-SP.md": "./src/translations/help/sr-SP.md",
	"./sv-SE.md": "./src/translations/help/sv-SE.md",
	"./th-TH.md": "./src/translations/help/th-TH.md",
	"./tk-TM.md": "./src/translations/help/tk-TM.md",
	"./tr-TR.md": "./src/translations/help/tr-TR.md",
	"./tu-TI.md": "./src/translations/help/tu-TI.md",
	"./uk-UA.md": "./src/translations/help/uk-UA.md",
	"./ur-PK.md": "./src/translations/help/ur-PK.md",
	"./vi-VN.md": "./src/translations/help/vi-VN.md",
	"./zh-CN.md": "./src/translations/help/zh-CN.md",
	"./zu-ZA.md": "./src/translations/help/zu-ZA.md"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/translations/help sync recursive ^\\.\\/.*\\.md$";